export default "__VITE_ASSET__D$w8Tw6z__"